import SvgCheck from "@uui/Check";
import SvgStars02 from "@uui/Stars02";
import SvgThumbsDown from "@uui/ThumbsDown";

import styled from "@mui/material/styles/styled";
import Typography from "@mui/material/Typography";

import {
  ActionItemChipStatus,
  ActionItemClipStatus,
  AutoStatus,
  UserStatus,
} from "@app/common/types";

import Menu, { MenuProps } from "@rui/Menu";
import Stack, { Row } from "@rui/Stack";

import StatusChip from "./StatusChip";
import { AUTO_ACTION_ITEM_STATUSES } from "../constants/statusChips";

const READ_GENERATED_TO_USER_GENERATED: {
  [key in AutoStatus]: UserStatus;
} = {
  read_inactive: "user_inactive",
  read_active: "user_active",
  read_complete: "user_complete",
};

const STATUSES: ActionItemChipStatus[] = [
  "user_inactive",
  "user_active",
  "user_complete",
];

const MenuItem = styled(Row)(({ theme }) => ({
  minWidth: "150px",
  padding: theme.spacing(0.5),
  width: "100%",
  borderRadius: "4px",
  "&:hover": {
    cursor: "pointer",
    backgroundColor: theme.palette.shades.neutral[50],
  },
}));

const ChangeStatusMenu = ({
  open,
  onClose,
  anchorEl,
  status,
  onChangeStatus,
}: MenuProps & {
  status?: ActionItemClipStatus;
  onChangeStatus: (s: ActionItemClipStatus) => void;
}) => {
  const isAutoStatus = status && AUTO_ACTION_ITEM_STATUSES.includes(status);

  const statusIsSelected = (s: ActionItemClipStatus) =>
    s === status ||
    (isAutoStatus &&
      s === READ_GENERATED_TO_USER_GENERATED[status as AutoStatus]);

  return (
    <Menu open={open} onClose={onClose} anchorEl={anchorEl}>
      <Stack spacing={0.5}>
        {STATUSES.map((s) => (
          <MenuItem
            variant="apart"
            key={s}
            onClick={(e) => {
              e.stopPropagation();
              onChangeStatus(s);
            }}
          >
            <StatusChip status={s} />
            {status && statusIsSelected(s) && (
              <SvgCheck sx={{ fontSize: "16px" }} />
            )}
          </MenuItem>
        ))}
        <MenuItem
          variant="left"
          spacing={1}
          key="user_reject"
          onClick={(e) => {
            e.stopPropagation();
            onChangeStatus("user_reject");
          }}
          sx={{ color: "shades.neutral.500" }}
        >
          <SvgThumbsDown sx={{ fontSize: "12px" }} />
          <Typography variant="detailReg" sx={{ fontSize: "12px" }}>
            Not an action item
          </Typography>
        </MenuItem>
        {status && isAutoStatus && (
          <Stack
            sx={{
              padding: 1,
              borderRadius: "4px",
              backgroundColor: "shades.ghost.300",
              maxWidth: "200px",
              fontSize: "11px",
              color: "shades.neutral.500",
            }}
          >
            <Row variant="left" spacing={0.5}>
              <SvgStars02
                sx={{ fontSize: "12px", color: "shades.secondary.500" }}
              />
              <Typography variant="detailReg" fontSize="inherit">
                Status auto-detected by Read.
              </Typography>
            </Row>
            <Typography variant="detailReg" fontSize="inherit">
              Changing the status means Read will no longer auto-update.
            </Typography>
          </Stack>
        )}
      </Stack>
    </Menu>
  );
};

export default ChangeStatusMenu;
